


// ThemeContext.js
import React, { createContext, useState, useEffect } from "react";
import { getThemeForAdminAndClient } from "./components/CommonAPI/Common";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "Light");
  const [availableThemes, setAvailableThemes] = useState([]);

  const fetchTheme = async () => {
    try {
      const response = await getThemeForAdminAndClient();
      if (response.Status) {
        setAvailableThemes(response?.Data || []);
        // Set in Body data-theme attribute
        let ThemeName = response?.Data[0] || "Light";
      
        document.body.setAttribute("data-theme", ThemeName);
        localStorage.setItem("theme", ThemeName);
      
      }
    } catch (error) {
      console.error("Error fetching themes:", error);
    }
  };

  useEffect(() => {
    fetchTheme();
  }, []);

  useEffect(() => {
    document.body.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const changeTheme = (newTheme) => {
    if (availableThemes.includes(newTheme)) {
      setTheme(newTheme);
    }
  };

  return (
    <ThemeContext.Provider value={{ theme, changeTheme, availableThemes }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => React.useContext(ThemeContext);
